<template>
  <div class="surveyform">
    <h1 class="text-center mb-3">Edit Survey Question</h1>
    <div class="row reading-form-container">
      <div class="flex content-center flex-wrap items-center">
        <div class="pr-5">CONTENT:</div>
        <div class="w-3/5">
          <input
            v-model="surveyQuestions.content"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="flex content-center flex-wrap items-center">
        <div class="pr-5">TITLE:</div>
        <div class="w-3/5">
          <input
            v-model="surveyQuestions.title"
            type="text"
            step="1"
            class="input-box-course-creators"
          />
        </div>
      </div>
      <div class="form-group">
        <div v-for="(item, key) in surveyQuestions.response_map" :key="key">
          <div class="flex items-center">
            <div class="mr-2">{{ key }})</div>
            <div v-if="key == 4">
              <img src="./public/images/emoji-satisfied.svg" />
            </div>
            <div v-if="key == 3">
              <img src="./public/images/emoji-slightly-smiling-face.svg" />
            </div>
            <div v-if="key == 2">
              <img src="./public/images/emoji-neutral-face.svg" />
            </div>
            <div v-if="key == 1">
              <img src="./public/images/emoji-frowning-face.svg" />
            </div>
            <div>
              <p class="text-xl mx-1 my-10">
                {{ capitalizeString(item.emojiName) }}
              </p>
            </div>
          </div>
          <form class="form-inline">
            <div>Subtitles:</div>
            <div class="form-group">
              <div
                v-for="(subtitles, index) in item.subtitles"
                :key="index"
                class="mx-5 my-2"
              >
                <textarea
                  v-model="item.subtitles[index]"
                  type="text"
                  class="resize border rounded focus:outline-none"
                  cols="60"
                  rows="2"
                />
              </div>
            </div>
            <div>Tags:</div>
            <div class="form-group">
              <div
                v-for="(tags, tag_index) in item.tags"
                :key="tag_index"
                class="w-3/5 flex items-center"
              >
                <input
                  v-model="item.tags[tag_index]"
                  type="text"
                  class="input-box-course-creators col-md-8"
                />
                <button
                  class="btn btn-red col-sm-2"
                  style="padding:mx-0;background:red"
                  @click.prevent="removeTag(key, tag_index)"
                >
                  remove
                </button>
              </div>
              <button class="btn btn-red" @click.prevent="addTag(key)">
                add tag
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="form-group">
        <h3>To schedule a survey</h3>
        <div class="flex content-center flex-wrap items-center mb-2">
          <div class="pr-5">delta_days:</div>
          <div class="w-3/5">
            <input
              v-model.number="delta_days"
              type="number"
              class="form-control form-control-md"
            />
          </div>
        </div>
        <div class="flex content-center flex-wrap items-center">
          <div class="pr-5">Add Cohort:</div>
          <div class="w-3/5">
            <VueSelect
              v-model="cohorts"
              :options="cohortOptions"
              label="name"
              :multiple="true"
            />
          </div>
        </div>
      </div>
      <div>
        <button
          style="border-radius:20px;"
          class="btn-primary bg-orange border-none leading-snug px-4 py-2 text-white my-4 hover:bg-green-900"
          @click="scheduleSurvey"
        >
          SCHEDULE
        </button>
      </div>
      <div v-if="surveyQuestions.recent_schedule_status">
        <h3>SCHEDULE INFO:</h3>
        <div
          v-for="(item, key) in surveyQuestions.recent_schedule_status"
          :key="key"
        >
          <div
            v-if="
              key == 'delta_days' || key == 'cohorts' || key == 'scheduled_on'
            "
            class="flex items-center m-5"
          >
            <p>{{ key }}:</p>
            <p class="ml-8">{{ item }}</p>
          </div>
        </div>
        <div>
          <button
            style="border-radius:20px;"
            class="btn-primary bg-orange border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900"
            @click="unscheduleSurvey"
          >
            UNSCHEDULE
          </button>
        </div>
      </div>
      <div>
        <button
          style="border-radius:20px;"
          class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-4 hover:bg-green-900"
          @click="updateQuestion"
        >
          UPDATE QUESTION
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      surveyQuestions: {},
      delta_days: 7,
      cohortOptions: [],
      cohorts: [],
      list: [],
    }
  },
  created() {
    this.getSurveyQuestions()
    this.getcohortList()
  },
  methods: {
    getcohortList() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const data = res.data.items
          this.cohortOptions = data.map(item => ({
            id: item.id,
            name: item.name,
          }))
        })
        .catch(err => {
          this.$noty.error(`Failed to get the cohorts ${err}`)
        })
    },
    getSurveyQuestions() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}survey/questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.surveyQuestions = res.data.survey_questions
          window.pageTitle = `Edit - ${this.surveyQuestions.title}`
        })
        .catch(err => {
          this.$noty.error(`Failed to get the survey data ${err}`)
        })
    },
    scheduleSurvey() {
      this.list = this.cohorts.map(item => item.id)
      const data = {
        delta_days: this.delta_days,
        cohorts: this.list,
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}survey/questions/${this.$route.params.id}/schedule`,
        data,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("Added a schedule")
        })
        .catch(err => {
          this.$noty.error(`Failed to add schedule ${err}`)
        })
    },
    unscheduleSurvey() {
      const surveyData = this.surveyQuestions.recent_schedule_status
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}survey/questions/${this.$route.params.id}/cancel`,
        data: surveyData,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("schedule was removed successfully")
        })
        .catch(err => {
          this.$noty.error(`Failed to remove schedule ${err}`)
        })
    },
    updateQuestion() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}survey/questions/${this.$route.params.id}`,
        data: this.surveyQuestions,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("survey questions updated successfully")
          this.$router.push({ name: "SurveyQuestionList" })
        })
        .catch(err => {
          this.$noty.error(`Failed to update the survey questions ${err}`)
        })
    },
    removeTag(key, tag_index) {
      this.surveyQuestions.response_map[key].tags.splice(tag_index, 1)
    },
    addTag(key) {
      this.surveyQuestions.response_map[key].tags.push("Add a new Tag")
    },
    capitalizeString(str) {
      return (
        str.substring(0, 1).toUpperCase() + str.substring(1, str.length)
      ).replace(/-/g, " ")
    },
  },
}
</script>

<style scoped>
.form-group {
  margin: 2px;
}
.surveyform {
  max-width: 70%;
  margin: auto;
}
.btn {
  width: 100px;
  height: auto;
  margin: 10px;
  padding: 5px;
  border-radius: 10px;
  color: white;
  background-color: #39be70;
  box-shadow: 0 2px 3px 0 #575757;
  text-shadow: none;
  font-weight: 500;
}
img {
  width: 2em;
  height: 3em;
  margin-top: -3px;
}
</style>
